<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{data.id ? 'Edit' : 'Create'}} an Incident Report</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Type ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Type</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText type-dropdown-z-index-increase">
                            <search-select [ngModel]="data.incidentReportType.id"
                                           name="incidentReportType"
                                           required
                                           #incidentTypeSelect
                                           [data]="typeSelect(incidentTypes)">
                            </search-select>

                            <input *ngIf="incidentTypeSelect.value == '0'"
                                   class="form-control"
                                   [ngModel]="data.incidentReportTypeOther"
                                   name="incidentReportTypeOther"
                                   placeholder="Other Type"
                                   maxlength="255"
                                   required>
                        </div>
                    </div>

                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control"
                                    name="buildingId"
                                    [ngModel]="data.buildingId"
                                    (change)="changeBuilding($event.target.value)"
                                    #buildingSelect
                                    [disabled]="buildingSelectIsDisabled" required>
                                <option value="" hidden></option>
                                <option *ngFor="let build of incidentReportsService.buildingsForUpdate" [value]="build.id">{{build.name}}</option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Unit ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Unit</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <search-select [ngModel]="data.suiteId"
                                           name="suiteId"
                                           #suiteSelect
                                           required
                                           (ngModelChange)="changeUnit($event)"
                                           [data]="suiteToSearchSelect(suites)">
                            </search-select>
                            <input *ngIf="suiteSelect.value == '0'"
                                   class="form-control"
                                   [ngModel]="data.suiteNumber"
                                   name="otherSuite"
                                   placeholder="Other Unit Number"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="buildingSelect.value &&
                                                    buildingSelect.value != 'null' &&
                                                    !suites.length && !isEditModeNoSpinner">
                            </spinner>
                        </div>
                    </div>

                    <!-- ___ Resident ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Resident</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control"
                                    [ngModel]="data.residentId"
                                    name="residentId"
                                    #residentSelect
                                    required
                                    (change)="changeResident($event.target.value)"
                                    [disabled]="!residents.length">
                                <option value="" hidden></option>
                                <option *ngFor="let resident of residents" [value]="resident.id">{{resident.fullName}}</option>
                            </select>
                            <input *ngIf="suiteSelect.value == '0' || residentSelect.value == '0'"
                                   class="form-control"
                                   placeholder="Other Resident Name"
                                   [ngModel]="data.residentFullName"
                                   name="otherResident"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="suiteSelect.value &&
                                                    suiteSelect.value != 'null' &&
                                                    !residents.length && !isEditModeNoSpinner">
                            </spinner>
                        </div>
                    </div>

                    <!-- ___ Date / Time Created On ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Happened At</label>
                        </div>
                        <div class="col-md-8 inlineDateAndTime">
                            <mat-form-field>
                                <input matInput
                                       [(ngModel)]="date"
                                       [max]="maxDate"
                                       name="date"
                                       (focus)="picker.open()"
                                       (click)="picker.open()"
                                       [matDatepicker]="picker"
                                       placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                            <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker()">
                                <input id="timepicker1" class="form-control input-small" name="time" [ngModel]="time" required>
                                <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                            </div>
                        </div>
                    </div>

                    <!-- ___ Report Area ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Report Area</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="reportedArea" [ngModel]="data.reportedArea">
                        </div>
                    </div>

                    <!-- ___ Reported By ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Reported By</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="reportedBy" [ngModel]="data.reportedBy" required>
                        </div>
                    </div>

                    <!-- ___ Incident  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Incident</label>
                        </div>
                        <div class="col-md-8">
                            <textarea class="form-control incident-textarea"
                                      name="incident"
                                      [ngModel]="data.incident" required>
                            </textarea>
                        </div>
                    </div>

                    <!-- ___ Images  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-xs-4 col-md-4">
                            <label>Attachments</label>
                        </div>
                        <div class="col-xs-8 col-md-8">
                            <input type="file"
                                   name="attachment"
                                   id="add-attachment-button"
                                   (change)="addFile($event)"
                                   hidden
                                   [disabled]="disabledFileInput">
                            <label for="add-attachment-button" class="btn mtv-primary-color">Add Attachment</label>
                        </div>
                    </div>
                    <ul class="attachment-box">
                        <li *ngFor="let item of attachments; let i = index;">
                            <a (click)="incidentReportsService.showAttachment(item)">
                                <div>
                                    <span class="file-name">{{item.name}}</span>
                                </div>
                            </a>
                            <i class="fa fa-trash" (click)="removeFile(i)" title="Delete Attachment"></i>
                        </li>
                    </ul>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>

                    <spinner [spinnerShow]="showSpinner"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>
<view-attachment-modal *ngIf="incidentReportsService.es.isViewAttachmentModalShow"></view-attachment-modal>



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-reports-modal/incident-reports-modal.component.html